





















import { Vue, Component, Prop } from "vue-property-decorator";
import * as images from "../../assets/images";
//@ts-ignore
import * as pdfMake from "pdfmake/build/pdfmake";
//@ts-ignore
import * as pdfFonts from "pdfmake/build/vfs_fonts";
pdfMake.vfs = pdfFonts.pdfMake.vfs;
@Component
export default class FoglioFirmeReview extends Vue {
  @Prop() docInfo!: any;
  private dd: any;
  private totOre: number;

  private noElements: boolean;

  constructor() {
    super();
    this.dd = null;
    this.totOre = 0;
    this.noElements = true;
  }

  createDoc() {
    const pdfDocGenerator = pdfMake.createPdf(this.dd);
    pdfDocGenerator.getDataUrl(function(dataUrl: any) {
      const targetElement = document.querySelector("#iframeContainer");
      const embed = document.createElement("embed");
      embed.src = dataUrl;
      embed.width = "1000";
      embed.height = "700";
      if (targetElement !== null) {
        targetElement.appendChild(embed);
      }
    });
  }

  loadFirme() {
    var firmaTutor: string = "";
    if (this.docInfo.length > 0) {
      this.noElements = false;
      for (let x = 0; x < this.docInfo.length; x++) {
        this.totOre = this.totOre + this.docInfo[x].oreGiornaliere;
      }
      if (this.docInfo[0].firmaTutorAzienda === null) {
        firmaTutor = images.noFirma;
      } else {
        firmaTutor = this.docInfo[0].firmaTutorAzienda;
      }
      var tmpStr = '{ "pageSize": "A4",' + ' "content": [';
      tmpStr +=
        '{ "text": "PCTO", "bold": "true", "alignment": "center", "fontSize": 14 },';
      tmpStr +=
        '{ "text": "PERCORSO PER LE COMPETENZE TRASVERSALI E PER L’ORIENTAMENTO", "alignment": "center", "fontSize": 8},';
      tmpStr +=
        '{ "text": "(di cui alla Legge di Bilancio 2019, intervenuta su A.S.L. Legge 107/2015 “Buona Scuola” e s.m.i.)", "alignment": "center", "fontSize": 8, "margin": [0, 0, 0, 15] },';
      tmpStr +=
        '{ "text": "REGISTRO PRESENZE GIORNALIERE", "bold": "true", "alignment": "center", "fontSize": 14},';
      tmpStr +=
        '{ "text": "(A CURA DEL TUTOR AZIENDALE)", "alignment": "center", "fontSize": 8, "margin": [0,0,0,15]},';
      tmpStr += '{ "table": {';
      tmpStr += ' "widths": [250,"*"],';
      tmpStr += ' "body": [';
      tmpStr += "[";
      tmpStr += '{ "text": "Soggetto Promotore", "style": "tableTitle"},';
      tmpStr +=
        '{ "text": "' +
        this.docInfo[0].denominazioneIstituto +
        '", "style": "tableText"}';
      tmpStr += "],";
      tmpStr += "[";
      tmpStr += '{ "text": "Soggetto Ospitante", "style": "tableTitle"},';
      tmpStr +=
        '{ "text": "' +
        this.docInfo[0].denominazioneAzienda +
        '", "style": "tableText"}';
      tmpStr += "],";
      tmpStr += "[";
      tmpStr += '{ "text": "Studente Tirocinante", "style": "tableTitle"},';
      tmpStr +=
        '{ "text": "' +
        this.docInfo[0].tirocinante +
        '", "style": "tableText"}';
      tmpStr += "],";
      tmpStr += "[";
      tmpStr +=
        '{ "text": "Codice Fiscale Tirocinante", "style": "tableTitle"},';
      tmpStr +=
        '{ "text": "' +
        this.docInfo[0].cfTirocinante +
        '", "style": "tableText"}';
      tmpStr += "]";
      tmpStr += "]";
      tmpStr += '}, "margin": [0,0,0,15]';
      tmpStr += "},";

      tmpStr += '{ "table": {';
      tmpStr += ' "widths": [100,150,150,75],';
      tmpStr += ' "body": [';
      tmpStr += "[";
      tmpStr += '{ "text": "Data", "style": "tableCol1"},';
      tmpStr += '{ "text": "Orario Mattino", "style": "tableCol1"},';
      tmpStr += '{ "text": "Orario Pomeriggio", "style": "tableCol1"},';
      tmpStr += '{ "text": "Ore", "style": "tableCol1"}';
      tmpStr += "],";
      for (let i = 0; i < this.docInfo.length; i++) {
        tmpStr += "[";
        tmpStr +=
          '{ "text": "' +
          this.docInfo[i].dataFirma +
          '", "style": "tableText1"},';
        tmpStr +=
          '{ "text": "' +
          this.docInfo[i].orarioMattino +
          '", "style": "tableText1"},';
        tmpStr +=
          '{ "text": "' +
          this.docInfo[i].orarioPomeriggio +
          '", "style": "tableText1"},';
        tmpStr +=
          '{ "text": "' +
          this.docInfo[i].oreGiornaliere +
          '", "style": "tableText1"}';
        tmpStr += "],";
      }
      tmpStr += "[";
      tmpStr += '{ "text": "", "style": "tableText1"},';
      tmpStr += '{ "text": "", "style": "tableText1"},';
      tmpStr += '{ "text": "Totale Ore Svolte", "style": "tableCol1"},';
      tmpStr += '{ "text": "' + this.totOre.toFixed(1) + '", "style": "tableText1"}';
      tmpStr += "]";
      tmpStr += "]";
      tmpStr += '}, "margin": [0,0,0,15]';
      tmpStr += "},";

      //  tmpStr += '{ "text": "Il Tutor Aziendale,"}'
      tmpStr +=
        '{ "text": "Firma Tutor Aziendale", "fontSize": 10, "alignment": "right"},';
      tmpStr +=
        '{ "text": "' +
        this.docInfo[0].tutorAziendale +
        '","fontSize": 10, "alignment": "right","bold": "true"},';
      tmpStr +=
        '{ "image": "' + firmaTutor + '", "width": 200, "alignment": "right"}';
      tmpStr += "],";
      tmpStr += '"styles": {';
      tmpStr += '"bodyText": { "fontSize": "8",  "justified": "true"},';
      tmpStr +=
        '"tableTitle": { "fontSize": "8", "bold": "true", "alignment": "left"},';
      tmpStr +=
        '"tableCol1": { "fontSize": 8, "alignment": "center","bold": "true"},';
      tmpStr += '"tableText": { "fontSize": 8 },';
      tmpStr += '"tableText1": { "fontSize": 8,"alignment": "center" }';
      tmpStr += "}";
      tmpStr += "}";
      this.dd = JSON.parse(tmpStr);

      this.createDoc();
    }
  }

  created() {
    this.loadFirme();
  }
}
